export const ALLOWED_IMAGE_TYPES = [
  `image/svg+xml`,
  `image/png`,
  `image/jpeg`,
  `image/jpg`,
  `image/webp`,
];
export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export function validateImageFile(file: File): {
  valid: boolean;
  error?: string;
} {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return {
      valid: false,
      error: `Only SVG, PNG, JPG, and WebP files are allowed`,
    };
  }

  if (file.size > MAX_FILE_SIZE) {
    return { valid: false, error: `File size must be less than 5MB` };
  }

  return { valid: true };
}
